<template>
  <v-layout row wrap justify-center>
    <v-flex xs12>
      <v-subheader>EQUIPES</v-subheader>
      <v-card style="border-radius: 10px">
        <v-flex xs12>
          <v-card style="border-radius: 10px">
            <v-container fluid grid-list-md>
              <v-layout row wrap justify-space-around align-center v-if="allChampTeams">
                <v-flex v-for="(team, idx) in allChampTeams" :key="'ct'+idx" lg3 sm4 xs12>
                  <v-card
                    :style="{borderRadius: '10px', cursor: !is_owner? 'pointer' : 'arrow'}"
                    @click="!is_owner? (allPlayers = true, one_team_index = idx) : ''"
                  >
                    <v-flex ml-3>
                      <v-avatar :size="avatarSize" color="white">
                        <v-img
                          v-if="team.team_logo"
                          :src="team.team_logo"
                          alt="avatar"
                          aspect-ratio="1"
                          style="border-radius: 12px"
                          contain
                        ></v-img>
                        <v-icon :size="avatarSize*56/100" v-if="!team.team_logo">fa-shield-alt</v-icon>
                      </v-avatar>
                    </v-flex>
                    <v-card-title primary-title>
                      <h3>{{team.team_name}}</h3>
                    </v-card-title>
                    <v-divider light class="mt-2"></v-divider>
                    <v-card-actions class="justify-end" v-if="is_owner">
                      <v-btn
                        color="primary"
                        flat
                        icon
                        @click="allPlayers=true, one_team_index = idx"
                      >
                        <v-icon>fa-users-cog</v-icon>
                      </v-btn>
                      <v-btn color="primary" flat icon @click="editTeam=true, one_team_index = idx">
                        <v-icon>fa-shield-alt</v-icon>
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-flex>
                <v-alert
                  type="info"
                  :value="true"
                  v-if="!allChampTeams || allChampTeams.length == 0"
                >Ainda não possui nenhuma equipe</v-alert>
              </v-layout>
              <v-fab-transition v-if="is_owner && !hasWinners">
                <v-btn
                  color="#fb8c00"
                  :fixed="isMobile()?  true : false"
                  :absolute="isMobile()?  false : true"
                  bottom
                  right
                  fab
                  @click="addTeam=true"
                >
                  <v-icon color="primary">add</v-icon>
                </v-btn>
              </v-fab-transition>
            </v-container>
          </v-card>
        </v-flex>

        <v-layout
          justify-space-around
          class="text-xs-center"
          v-if=" false && allChampTeams.length<number_teams"
        >
          <v-btn color="primary" @click="addTeam=true" class="white--text">
            <v-icon left>add</v-icon>Equipes
          </v-btn>
        </v-layout>

        <v-dialog v-model="addTeam" v-if="addTeam" width="500" persistent>
          <v-card>
            <v-toolbar color="primary" dark>
              <v-toolbar-title class="white--text">Adicionar Equipe</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn color="white" flat icon @click="addTeam=false, teamName=null, clearAvatar()">
                <v-icon>close</v-icon>
              </v-btn>
            </v-toolbar>
            <v-card-text>
              <v-text-field
                v-model="teamName"
                auto-grow
                color="primary"
                label="Nome da Equipe"
                rows="1"
              ></v-text-field>
              <v-spacer></v-spacer>
              <div class="text-xs-center">
                <v-layout row wrap justify-center>
                  <v-flex xs12 md12 sm12>
                    <Uploader64
                      txt="Galeria"
                      icon="add_circle"
                      @getSelectedFile="logoAux = $event"
                    />
                  </v-flex>
                  <v-flex mt-4 xs12 md12 sm12>
                    <v-avatar :size="avatarSize" color="grey lighten-4">
                      <v-icon
                        :size="avatarSize*56/100"
                        color="grey lighten-1"
                        v-if="!avatarURL"
                      >fa-shield-alt</v-icon>
                      <v-img
                        v-if="avatarURL"
                        :src="avatarURL"
                        alt="avatar"
                        aspect-ratio="1"
                        class="grey lighten-5"
                        style="border-radius: 12px"
                        contain
                      />
                    </v-avatar>
                  </v-flex>
                  <v-flex>
                    <v-btn
                      v-if="avatarURL"
                      @click="clearAvatar"
                      icon
                      round
                      large
                      color="white"
                      class="primary--text"
                    >
                      <v-icon>delete</v-icon>
                    </v-btn>
                  </v-flex>
                </v-layout>
              </div>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" flat :disabled="!teamName" @click="addChampTeam()">Salvar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="editTeam" width="500" persistent v-if="editTeam">
          <v-card>
            <v-toolbar color="primary" dark>
              <v-toolbar-title class="white--text">Editar Equipe</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn color="white" flat icon @click="closeEdit()">
                <v-icon>close</v-icon>
              </v-btn>
            </v-toolbar>
            <v-card-text>
              <v-text-field
                v-model="oneTeam.team_attributes.name"
                color="primary"
                label="Nome da Equipe"
              ></v-text-field>
              <v-spacer></v-spacer>
              <v-layout row wrap justify-center>
                <v-flex xs12 md12 sm12>
                  <Uploader64 txt="Alterar Logo" icon="create" @getSelectedFile="logoAux = $event" />
                </v-flex>
                <v-flex xs12 md12 sm12>
                  <v-avatar :size="avatarSize" color="grey lighten-4">
                    <v-icon
                      v-if="!avatarURL"
                      :size="avatarSize*56/100"
                      color="grey lighten-1"
                    >fa-shield-alt</v-icon>
                    <v-img
                      v-if="avatarURL"
                      :src="avatarURL"
                      alt="avatar"
                      aspect-ratio="1"
                      class="grey lighten-5"
                      style="border-radius: 12px"
                      contain
                    />
                  </v-avatar>
                </v-flex>
                <!-- <v-flex>
                  <v-btn
                    v-if="avatarURL"
                    @click="clearAvatar"
                    icon
                    round
                    large
                    color="white"
                    class="primary--text"
                  >
                    <v-icon>delete</v-icon>
                  </v-btn>
                </v-flex>-->
                <v-flex></v-flex>
              </v-layout>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" flat @click="updateTeam()">Salvar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog
          v-model="allPlayers"
          width="500"
          persistent
          scrollable
          max-height="400px"
          v-if="allPlayers"
        >
          <v-card>
            <v-card-title class="pa-0" primary-title>
              <v-toolbar color="primary" dark>
                <v-layout row wrap justify-space-around align-center>
                  <v-flex xs5>
                    <v-toolbar-title class="white--text">Jogadores</v-toolbar-title>
                  </v-flex>
                  <v-flex xs4 sm5>
                    <!-- <v-text-field
                      v-model="search"
                      append-icon="search"
                      label="Encontrar"
                      single-line
                    ></v-text-field>-->
                  </v-flex>
                  <v-flex xs1 class="text-xs-center">
                    <v-btn color="white" flat icon @click="allPlayers=false">
                      <v-icon>close</v-icon>
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-toolbar>
            </v-card-title>
            <v-card-text style="max-height: 500px;">
              <v-data-table
                :headers="headers"
                :items="table_items"
                :search="search"
                v-if="headers!='' && headers!=null"
                rows-per-page-text="Linhas por Página"
                hide-actions
              >
                <template slot="items" slot-scope="props">
                  <td class="text-xs-center">{{ props.item.player_name }}</td>
                  <td v-if="is_owner" class="text-xs-center">{{ props.item.identification_number }}</td>
                  <td v-if="is_owner">
                    <v-btn icon @click="editPlayer=true, one_squad_id = props.item.id">
                      <v-icon>create</v-icon>
                    </v-btn>
                  </td>
                </template>
                <template slot="no-results">
                  <v-alert
                    :value="true"
                    color="error"
                    icon="warning"
                  >Nenhum jogador "{{ search }}" encontrado.</v-alert>
                </template>
                <template slot="no-data">
                  <v-alert :value="true" color="warning" icon="warning">
                    <strong>{{one_team_name.toUpperCase()}}</strong> ainda não tem nenhum jogador
                  </v-alert>
                </template>
              </v-data-table>
            </v-card-text>
            <v-card-actions class="justify-center" v-if="is_owner">
              <v-btn
                round
                color="primary"
                class="white--text text--accent-3"
                large
                dark
                mb-2
                @click="addPlayer=true"
              >
                Adicionar jogadores
                <v-icon right dark>fa-plus</v-icon>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="addPlayer" width="500" persistent v-if="addPlayer && oneSquad">
          <v-card>
            <v-toolbar color="primary" dark>
              <v-toolbar-title class="white--text">Adicionar Jogador</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn color="white" flat icon @click="addPlayer=false">
                <v-icon>close</v-icon>
              </v-btn>
            </v-toolbar>
            <v-card-text>
              <h3 class="primary--text mb-3">{{one_team_name}}</h3>
              <v-text-field
                v-model="oneSquad.player_attributes.name"
                color="primary"
                box
                label="Nome do atleta"
              ></v-text-field>
              <v-spacer></v-spacer>
              <v-text-field
                v-model="oneSquad.player_attributes.identification_number"
                color="primary"
                box
                label="ID do Atleta"
                mask="###############"
              ></v-text-field>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="primary"
                flat
                :disabled="!oneSquad.player_attributes.name || !oneSquad.player_attributes.identification_number"
                @click="addSquad()"
              >Adicionar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="editPlayer" width="500" persistent v-if="editPlayer">
          <v-card>
            <v-toolbar color="primary" dark>
              <v-toolbar-title class="white--text">Editar Jogador</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn color="white" flat icon @click="editPlayer=false">
                <v-icon>close</v-icon>
              </v-btn>
            </v-toolbar>
            <v-card-text>
              <v-text-field
                v-model="oneSquad.player_attributes.name"
                color="primary"
                box
                label="Nome do atleta"
              ></v-text-field>
              <v-spacer></v-spacer>
              <v-text-field
                v-model="oneSquad.player_attributes.identification_number"
                color="primary"
                box
                label="ID do Atleta"
              ></v-text-field>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" flat @click="editSquad()">Salvar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-card>
    </v-flex>
    <card-loading v-if="loading" :loadText="loadTxt"></card-loading>
  </v-layout>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { mapState, mapMutations } from "vuex";

import Api from "../../../api/index";

export default {
  components: {
    Uploader64: () => import("@/components/imports/_uploader_b64.vue")
  },
  props: {
    allChampTeams_arr: {
      type: Array
    },
    edition_modality_id: {
      type: Number
    }
  },
  data() {
    return {
      champ_team_squad: null,

      addTeam: false,
      addPlayer: false,
      editPlayer: false,
      allPlayers: false,
      editTeam: false,
      logoAux: null,
      newTeam: {
        team_attributes: {
          name: null,
          logo: null
        },
        edition_modality_id: null
      },
      teamName: null,
      playerName: null,
      playerID: null,
      search: "",

      loading: false,
      loadTxt: null,

      one_team_index: null,
      oneTeam: {
        team_attributes: {
          name: null,
          logo: null
        },
        edition_modality_id: null
      },
      one_squad_id: null,
      oneSquad: null,

      number_teams: 16,

      headers_aux: [
        {
          text: "Nome do Atleta",
          align: "left",
          sortable: false,
          value: "name"
        },
        { text: "Documento de Identidade", value: "identification_number" },
        { text: "Editar", value: "edit" }
      ],
      avatarSize: "110"
    };
  },
  computed: {
    ...mapGetters({
      hasWinners: "Championship/hasWinners"
    }),
    avatarURL() {
      if (this.oneTeam) {
        if (this.oneTeam.team_attributes.logo && !this.logoAux) {
          return this.oneTeam.team_attributes.logo;
        }
      }
      if (this.logoAux) {
        this.oneTeam.team_attributes.logo = {
          data: this.logoAux,
          filename: "logo" + this.team_name + ".png",
          content_type: "image/png"
        };
        this.newTeam.team_attributes.logo = {
          data: this.logoAux,
          filename: "logo" + this.team_name + ".png",
          content_type: "image/png"
        };
      }
      return this.logoAux;
    },
    headers() {
      if (this.allPlayers) {
        if (this.is_owner) {
          return this.headers_aux;
        } else {
          return [this.headers_aux[0]];
        }
      }
    },
    table_items() {
      if (
        this.allChampTeams &&
        parseInt(this.one_team_index) >= 0 &&
        this.champ_team_squad
      ) {
        return this.champ_team_squad.data
          .map(obj => obj.attributes)
          .sort(o => o.player_name);
      }
    },
    one_team_name() {
      if (
        this.allChampTeams &&
        this.one_team_index != null &&
        parseInt(this.one_team_index) >= 0
      ) {
        return this.allChampTeams[this.one_team_index].team_name;
      }
    },
    is_owner() {
      return this.oneChampionship.data.attributes.can_edit;
    },
    ...mapState({
      oneChampionship: state => state.Championship.oneChampionship,
      allChampTeams: state => state.ChampTeam.allChampTeams,
      user: state => state.Users.user,

      createTeamWasGood: state => state.Championship.createTeamWasGood,
      createTeamMessage: state => state.Championship.createTeamMessage,
      updateTeamWasGood: state => state.Championship.updateTeamWasGood,
      updateTeamMessage: state => state.Championship.updateTeamMessage,

      createSquadWasGood: state => state.Championship.createSquadWasGood,
      createSquadMessage: state => state.Championship.createSquadMessage,
      updateSquadWasGood: state => state.Championship.updateSquadWasGood,
      updateSquadMessage: state => state.Championship.updateSquadMessage
    })
  },
  methods: {
    teste() {},
    ...mapMutations({
      setAllChampTeams: "ChampTeam/setAllChampTeams"
    }),
    isMobile() {
      if (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
      ) {
        return true;
      } else {
        return false;
      }
    },

    getChampTeamSquad(team_id) {
      Api.Championship.indexChampTeamsSquads(team_id)
        .then(r => r.data)
        .then(data => {
          this.champ_team_squad = data;
        });
    },
    closeEdit() {
      this.editTeam = false;
      this.one_team_index = null;
    },
    clearAvatar() {
      this.logoAux = null;
      this.oneTeam.team_attributes.logo = null;
      this.newTeam.team_attributes.logo = null;
    },
    updateTeam() {
      this.loadTxt = "Salvando";
      this.loading = true;
      console.log(this.oneTeam.team_attributes.logo);
      this.updateChampTeam({ champTeam: this.oneTeam }).then(() => {
        setTimeout(() => {
          this.loading = false;
          this.loadTxt = null;
          this.one_team_index = null;
          this.editTeam = false;
          this.getChampTeams(this.$route.params.id);
          this.getOneChampionship({ id: this.$route.params.id });
          this.logoAux = "";
          this.newTeam = {
            team_attributes: {
              name: null,
              logo: null
            }
          };
          this.oneTeam = {
            team_attributes: {
              name: null,
              logo: null
            }
          };
        }, 1000);
      });
    },
    resetNewTeam() {
      this.newTeam = {
        team_attributes: { name: null },
        edition_modality_id: null
      };
      this.teamName = null;
    },
    addChampTeam() {
      let ok = true;
      this.loadTxt = "Salvando";
      this.loading = true;
      if (this.allChampTeams && this.allChampTeams.length > 0) {
        let uniq = this.allChampTeams.filter(
          ct => ct.team_name == this.teamName
        );
        if (uniq.length > 0) ok = false;
        else {
          this.newTeam.team_attributes.name = this.teamName;
          this.newTeam.edition_modality_id = this.$route.params.id;
        }
      } else {
        this.newTeam.team_attributes.name = this.teamName;
        this.newTeam.edition_modality_id = this.$route.params.id;
      }
      if (ok) {
        // console.log({ newTeam: this.newTeam });
        // setTimeout(() => {
        this.createChampTeam({ newChampTeam: this.newTeam });
        // this.loadTxt = null
        // this.loading = false
        // this.resetNewTeam()
        // }, 1500);
        this.logoAux = "";
        this.newTeam = {
          team_attributes: {
            name: null,
            logo: null
          },
          edition_modality_id: null
        };
        this.oneTeam = {
          team_attributes: {
            name: null,
            logo: null
          },
          edition_modality_id: null
        };
        this.addTeam = false;
      } else {
        console.log("not ok");
      }
    },
    addSquad() {
      this.loadTxt = "Salvando";
      this.loading = true;
      this.createSquad({ newSquad: this.oneSquad });
    },
    editSquad() {
      this.loadTxt = "Salvando";
      this.loading = true;
      this.updateSquad({ squad: this.oneSquad });
    },
    ...mapActions({
      getOneChampionship: "Championship/show",
      getChampTeams: "ChampTeam/index",
      createChampTeam: "Championship/createChampTeam",
      updateChampTeam: "ChampTeam/update",

      createSquad: "Championship/createSquad",
      updateSquad: "Championship/updateSquad"
    })
  },
  watch: {
    allChampTeams(nv, ov) {
      if (nv) {
        setTimeout(() => {
          this.loading = false;
          this.loadTxt = null;
        }, 200);
      } else if (nv == false) {
      }
    },
    createTeamWasGood(nv, ov) {
      if (nv) {
        setTimeout(() => {
          // this.loading = false;
          // this.loadTxt = null;
          this.resetNewTeam();
          this.getChampTeams(this.$route.params.id);
          // this.getOneChampionship({ id: this.$route.params.id });
        }, 500);
      }
    },
    updateTeamWasGood(nv, ov) {
      if (nv) {
        setTimeout(() => {
          // this.loading = false;
          // this.loadTxt = null;
          // this.one_team_index = null;
          // this.editTeam = false;
          // this.getChampTeams(this.$route.params.id);
          // this.getOneChampionship({ id: this.$route.params.id });
        }, 500);
      } else if (nv == false) {
      }
    },

    createSquadWasGood(nv, ov) {
      if (nv) {
        setTimeout(() => {
          this.loading = false;
          this.loadTxt = null;
          this.addPlayer = false;
          this.oneSquad.player_attributes.name = null;
          this.oneSquad.player_attributes.identification_number = null;
          this.getChampTeamSquad(this.oneSquad.team_id);

          // this.getOneChampionship({ id: this.$route.params.id });
        }, 500);
      } else if (nv == false) {
      }
    },
    updateSquadWasGood(nv, ov) {
      if (nv) {
        setTimeout(() => {
          this.loading = false;
          this.loadTxt = null;
          this.editPlayer = false;
          this.getChampTeamSquad(this.oneSquad.team_id);
        }, 1000);
      } else if (nv == false) {
      }
    },
    allPlayers(nv, ov) {
      if (nv) {
      } else if (nv == false) {
        this.champ_team_squad = null;
        this.one_team_index = null;
      }
    },
    one_team_index(nv, ov) {
      if (parseInt(nv) >= 0) {
        const {
          team_name,
          id,
          team_id,
          edition_modality_id,
          team_logo
        } = this.allChampTeams[nv];

        if (this.editTeam) {
          this.oneTeam = {
            id,
            team_attributes: {
              id: team_id,
              name: team_name,
              logo: team_logo
            }
          };
          // console.log(this.oneTeam.team_attributes.logo)
        } else if (this.allPlayers) {
          this.getChampTeamSquad(team_id);
        }
      } else {
        this.oneTeam = {
          team_attributes: {
            name: null,
            logo: null
          },
          edition_modality_id: null
        };
        this.oneSquad = null;
      }
    },
    editPlayer(nv, ov) {
      if (nv) {
        const {
          id,
          team_id,
          edition_modality_id,
          player_id,
          player_name,
          identification_number
        } = this.champ_team_squad.data
          .filter(obj => obj.id == this.one_squad_id)
          .map(obj => obj.attributes)[0];
        this.oneSquad = {
          id,
          team_id,
          edition_modality_id,
          player_attributes: {
            id: player_id,
            name: player_name,
            identification_number
          }
        };
      } else {
        this.oneSquad = null;
      }
    },
    addPlayer(nv, ov) {
      if (nv) {
        this.oneSquad = {
          team_id: this.allChampTeams[this.one_team_index].id,
          edition_modality_id: this.$route.params.id,
          player_attributes: {
            name: null,
            identification_number: null
          }
        };
      }
    }
  },
  mounted() {
    if (!this.allChampTeams) {
      this.getChampTeams(this.$route.params.id);
    }
  }
};
</script>

<style scoped>
.CardUser {
  padding: 20px;
}
</style>


